(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDashboardDetailController', WarningDashboardDetailController);

    WarningDashboardDetailController.$inject = ['frame', 'titlePage', 'fleetId', 'objectType', 'objectUniqueCode', 'warningCategory', 'warningName', 'detail'];

    function WarningDashboardDetailController(frame, titlePage, fleetId, objectType, objectUniqueCode, warningCategory, warningName, detail) {
        var vm = this;
        vm.frame = frame;
        vm.titlePage = titlePage;
        vm.detail = detail;

        vm.fleetId = fleetId;
        vm.objectType = objectType;
        vm.objectUniqueCode = objectUniqueCode;
        vm.warningCategory = warningCategory;
        vm.warningName = warningName;

        vm.oldURL = document.baseURI;
        vm.back = function() {
            window.location.href=vm.oldURL;
        };
    }
})();
